export default __webpack_public_path__ + "static/media/background.fda4c774.jpg";